// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/transportation/vessels/vessel.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyRequest } from "../../../common/messages/messages";
import {
  GetActiveVesselsResponse,
  GetAllVesselsResponse,
  GetVesselByImoRequest,
  UpdateVesselCertificateRequest,
  UpdateVesselReqeust,
  Vessel,
  VesselResponse,
} from "./vessel";

import { VesselServiceClientImpl } from "./vessel";

@Injectable({ providedIn: "root" })
export class VesselServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async getVesselByImo(request: GetVesselByImoRequest): Promise<VesselResponse> {
    const client = new VesselServiceClientImpl(this._rpc);
    return await client.getVesselByImo(request);
  }
  async addVessel(request: Vessel): Promise<VesselResponse> {
    const client = new VesselServiceClientImpl(this._rpc);
    return await client.addVessel(request);
  }
  async updateVessel(request: UpdateVesselReqeust): Promise<VesselResponse> {
    const client = new VesselServiceClientImpl(this._rpc);
    return await client.updateVessel(request);
  }
  async updateVesselCertificate(request: UpdateVesselCertificateRequest): Promise<VesselResponse> {
    const client = new VesselServiceClientImpl(this._rpc);
    return await client.updateVesselCertificate(request);
  }
  async getAllVessels(request: EmptyRequest): Promise<GetAllVesselsResponse> {
    const client = new VesselServiceClientImpl(this._rpc);
    return await client.getAllVessels(request);
  }
  async getActiveVessels(request: EmptyRequest): Promise<GetActiveVesselsResponse> {
    const client = new VesselServiceClientImpl(this._rpc);
    return await client.getActiveVessels(request);
  }
}
